<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex" />

    <b-navbar-nav class="nav align-items-center ml-auto">
      <li
        class="nav-item b-nav-dropdown dropdown dropdown-user"
        :class="{ show: isUserMenuOpen }"
      >
        <b-link
          id="navbar-user-menu"
          href="#"
          class="nav-link dropdown-toggle d-flex align-items-center dropdown-user-link"
          role="button"
          aria-haspopup="true"
          :aria-expanded="isUserMenuOpen ? 'true' : 'false'"
          @click.prevent.stop="toggleUserMenu"
        >
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ getUser.fullname }}
            </p>
            <span class="user-status">{{ getUser.role }}</span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="require('@/assets/images/avatars/13-small.png')"
            class="badge-minimal"
            badge-variant="success"
          />
        </b-link>

        <ul
          class="dropdown-menu dropdown-menu-right"
          :class="{ show: isUserMenuOpen }"
          aria-labelledby="navbar-user-menu"
        >
          <b-link
            to="/account-setting"
            class="dropdown-item d-flex align-items-center"
            @click="closeUserMenu"
          >
            <feather-icon
              size="16"
              icon="UserIcon"
              class="mr-50"
            />
            <span>Profile</span>
          </b-link>

          <div class="dropdown-divider" />

          <a
            class="dropdown-item d-flex align-items-center"
            href="/logout"
            @click="closeUserMenu"
          >
            <feather-icon
              size="16"
              icon="LogOutIcon"
              class="mr-50"
            />
            <span>Logout</span>
          </a>
        </ul>
      </li>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BAvatar,
} from 'bootstrap-vue'
import store from '@/store/index'

export default {
  components: {
    BLink,
    BNavbarNav,
    BAvatar,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isUserMenuOpen: false,
    }
  },
  computed: {
    getUser() {
      return store.state.app.user_data
    },
  },
  mounted() {
    document.addEventListener('click', this.onDocumentClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocumentClick)
  },
  methods: {
    toggleUserMenu() {
      this.isUserMenuOpen = !this.isUserMenuOpen
    },
    closeUserMenu() {
      this.isUserMenuOpen = false
    },
    onDocumentClick(event) {
      if (!this.$el.contains(event.target)) {
        this.closeUserMenu()
      }
    },
  },
}
</script>
